import { render, staticRenderFns } from "./ClimateDataTable.vue?vue&type=template&id=70ca91c6&"
import script from "./ClimateDataTable.vue?vue&type=script&lang=js&"
export * from "./ClimateDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports